import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FoundationsSelect } from '../../GenericComponents/select';
import { FoundationsButton } from '../../GenericComponents/button';
import { getBaseUrl } from '../../Utils';
import { AppDispatch } from '../../Redux/store';
import { GetDrillThruColumns } from '../../Redux/Admin_Tasks/MDSSlice';
import ConfirmationPage from './Confirmation';
import { FoundationsInput } from '../../GenericComponents/input';
import { FoundationsCheckBox } from '../../GenericComponents/checkbox';
import MDSCForm from './mdscform';

declare let window: any;

interface AddMDSCProps {
    SelectMetadataFormData: any;
    handleBackForm: () => void;
    isEdit?: boolean;
}
interface column {
    Id: number;
    MetaDataDrillThruSetId: number | null;
    MetaDataId: number | null;
    DataType: number;
    FieldId: number
    FieldName: string;
    DisplayOrder: number;
    TableName: string;
    ColumnName: string;
    EmptyColor: string;
    JavascriptTarget: string;
    JavascriptTargetParams: string;
    hideInDrillThru: boolean;
    APIContext: string;
    AllowedPrivileges: string;
    fk_ocvid: number | null;
    SortOrder: string;
    DisplayTruncateColumn: boolean;
    IsSortable: boolean;
    IsNavigationAllowed: boolean;
    fk_TableName: number;
    FieldDesc: string;
    JavascriptParameterTitle: string;
    ApiContext: string;
    storedProcedureToFetchTargetObject: string;
}
const AddMDSC: React.FC<AddMDSCProps> = ({ isEdit, SelectMetadataFormData, handleBackForm }) => {
    const [drillThruSetColumns, setdrillThruSetColumns] = useState<any[]>([]);
    const [selectedColumns, setSelectedColumns] = useState<any[]>([]);
    const [sortColumnsForOrderBy, setSortColumns] = useState<{ MetaDataId: number, FieldName: string, SortOrder: string }[]>([]);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
    const [currentColumnIndex, setCurrentColumnIndex] = useState(sortColumnsForOrderBy.length);
    const columnNames = selectedColumns?.map((item: any) => item.FieldName).join(', ');
    const [sortColumnName, setcolumnnames] = useState<any[]>([])
    const [additionalButtons, setAdditionalButtons] = useState<string>(
        JSON.stringify({ buttonsList: [] }, null, 2)
    );
    const [customcolunms, setcustomcol] = useState<any[]>([]);
    const [isCustomColumn, setIsCustomColumn] = useState<boolean>(false);

    function initializeColumn() {
        return {
            Id: 0,
            MetaDataDrillThruSetId: null,
            MetaDataId: null,
            DataType: 0,
            FieldName: "",
            DisplayOrder: 0,
            TableName: "",
            ColumnName: "",
            EmptyColor: "",
            JavascriptTarget: "",
            JavascriptTargetParams: "",
            hideInDrillThru: false,
            APIContext: "",
            AllowedPrivileges: "",
            fk_ocvid: -1,
            SortOrder: "",
            DisplayTruncateColumn: true,
            IsSortable: false,
            IsNavigationAllowed: false,
            Fk_TableName: -1,
            FieldDesc: '',
            JavascriptParameterTitle: '',
            ApiContext: '',
            storedProcedureToFetchTargetObject: ''
        };
    }
    const [showForm, setShowForm] = useState<boolean[]>(Array(selectedColumns.length + customcolunms.length).fill(false));
    const dispatch: AppDispatch = useDispatch();
    const openpp = (event: any) => {
        event.stopPropagation()
        const elementobj = document.getElementById('DrillThruSetName');
        if (elementobj) {
            var callbackdata = {};
            $(elementobj).data("ui_callbackhandler", "SelectMDSC_MappableAttributeHandler");
            $(elementobj).data("ui_callbackhandler_params", callbackdata);
            $(elementobj).data("SearchListType", "checkbox");

            window.hl_ui.allowFieldEdit(elementobj, 'serversearch', null, "SelectMDSC_MappableAttributeHandler", callbackdata);
            window.hl_ui.ui_serversearchlist(elementobj);
        }
    };

    (window as any).SelectMDSC_MappableAttributeHandler = SelectMDSC_MappableAttributeHandler;
    function SelectMDSC_MappableAttributeHandler(elementobj: any, action: string, params: any, keyvalues: any) {
        switch (action) {

            case "GETSELECTEDLIST":
                const selectedColumnforpp = selectedColumns?.map((item: any, index: number) => ({
                    KeyValue: item.MetaDataId,
                    DisplayText: item.FieldName
                        || (item.MetaData && item.MetaData.FieldName)
                        || item.ColumnName,
                }));
                return selectedColumnforpp;
                break;

            case "GETLIST":
                const searchTerm = keyvalues && typeof keyvalues === 'string' ? keyvalues.toLowerCase() : '';

                const filteredData = drillThruSetColumns.filter((item: any) =>
                    (item.FieldName
                        || (item.MetaData && item.MetaData.FieldName)
                        || item.ColumnName).toLowerCase().includes(searchTerm)
                );
                const result = filteredData.map((item: any, index: number) => ({
                    KeyValue: item.FieldKey,
                    DisplayText: item.FieldName
                        || (item.MetaData && item.MetaData.FieldName)
                        || item.ColumnName,

                }));
                $(elementobj).data("findresponselist", result);
                break;

            case "SAVE":
            case "UPDATE":
                if (keyvalues && Array.isArray(keyvalues)) {

                    const selectedFieldKeys = keyvalues.map((item: { KeyValue: any }) => Number(item.KeyValue));
                    const finalFilteredColumns = drillThruSetColumns.filter((item: any, index: number) => {
                        const KeyValue = item.FieldKey;
                        return selectedFieldKeys.includes(KeyValue);
                    });
                    handleSetColumns(finalFilteredColumns)
                }
                break;

            default:
                console.log('Unhandled action:', action);
                return null;
        }

    }
    const handleSetColumns = (finalFilteredColumns: any) => {
        const mappedcolumns = finalFilteredColumns.map((column: any) => ({
            Id: column.Id || 0,
            MetaDataDrillThruSetId: column.MetaDataDrillThruSetId || null,
            MetaDataId: column.MetadataId ?? column.FieldKey ?? null,
            DataType: column.DataType ?? column.MetaData?.DataType ?? 0,
            FieldName: column.FieldName ?? column.MetaData?.FieldName ?? column.ColumnName ?? "",
            DisplayOrder: column.DisplayOrder || 0,
            TableName: column.TableName || "",
            DrillThruType: column.DrillThruType || "",
            FactTableJoinKey: column.FactTableJoinKey || "",
            FactTableName: column.FactTableName || "",
            FieldKey: column.FieldKey || -1,
            FactGroupName: column.FactGroupName || "",
            ColumnName: column.ColumnName || "",
            EmptyColor: column.MetaData?.EmptyColor ?? "",
            JavascriptTarget: column.MetaData?.JavascriptTarget ?? "",
            JavascriptTargetParams: column.MetaData?.JavascriptTargetParams ?? "",
            hideInDrillThru: column.hideInDrillThru ?? false,
            APIContext: column.APIContext || "",
            AllowedPrivileges: column.AllowedPrivileges || "",
            fk_ocvid: column.fk_ocvid || null,
            SortOrder: column.SortOrder || "",
            DisplayTruncateColumn: column.DisplayTruncateColumn ?? true,
            IsSortable: column.IsSortable || false,
            IsNavigationAllowed: column.IsNavigationAllowed || false,
            Fk_TableName: column.fk_FactTable || -1,
            FieldDesc: column.MetaData?.FieldDesc ?? '',
            JavascriptParameterTitle: column.JavascriptParameterTitle || '',
            ApiContext: column.ApiContext || '',
            storedProcedureToFetchTargetObject: column.storedProcedureToFetchTargetObject || ''
        }));
        setSelectedColumns(mappedcolumns);
        return mappedcolumns;
    };
    useEffect(() => {
        const fetchColumns = async () => {
            try {
                let factGroupname = '';
                if (Array.isArray(SelectMetadataFormData.FactGroupName)) {
                    factGroupname = SelectMetadataFormData.FactGroupName[0];
                } else {
                    factGroupname = SelectMetadataFormData.FactGroupName;
                }

                const response = await dispatch(GetDrillThruColumns({
                    conditions: [
                        {
                            conditionType: 'factGroup',
                            conditionData: [factGroupname],
                        }
                    ]
                }));

                const columns = response.payload.data;
                setdrillThruSetColumns(columns);
                setShowForm(Array(columns.length).fill(false));

                if (isEdit) {
                    const sortColumnsForOrderBy = SelectMetadataFormData.SortColumnsForOrderBy.map((column: any) => ({
                        MetaDataId: column.MetaDataId,
                        FieldName: column.FieldName,
                        SortOrder: column.SortOrder
                    }));

                    // Filter columns where hideInDrillThru is false
                    //const filteredColumns = SelectMetadataFormData.drillThruSetColumns.filter((column: any) => !column.hideInDrillThru);

                    setSelectedColumns(SelectMetadataFormData.drillThruSetColumns || []);
                    setSortColumns(sortColumnsForOrderBy || []);
                    setAdditionalButtons(JSON.stringify(SelectMetadataFormData.AdditionalButtons || { buttonsList: [] }, null, 2));
                    setShowForm(Array(selectedColumns.length).fill(false));
                }
            } catch (error) {
                console.error('Error:', error);
            }
        };

        fetchColumns();
    }, [dispatch]);

    const addSortColumn = () => {
        const columns = selectedColumns;
        if (columns.length > 0) {
            setSortColumns(prev => [
                ...prev,
                { MetaDataId: -1, FieldName: '', SortOrder: 'asc' }
            ]);
            setCurrentColumnIndex(prev => prev + 1);
        }else{
            alert("Please select columns first")
        }
    };

    const toggleAdvancedSettings = () => setShowAdvancedSettings(prev => !prev);
    const deleteSortColumn = (index: number) => {
        setSortColumns(prev => prev.filter((_, i) => i !== index));
    };

    const handleSortColumnChange = (value: number | null, index: number) => {
        if (value != null) {
            setSortColumns(prev =>
                prev.map((col, i) => {
                    if (i === index) {
                        return { ...col, MetaDataId: value }; // Update with the new value
                    }
                    return col;
                })
            );
        }
    };


    const updateSortColumnsWithFieldNames = (drillThruSetColumns: any[], sortColumns: any[]) => {
        const fieldNameMap = drillThruSetColumns.reduce((acc: any, column: any) => {
            acc[column.MetaDataId] = column.FieldName;
            return acc;
        }, {});
        const updatedSortColumns = sortColumns.map((item: any) => ({
            ...item,
            FieldName: fieldNameMap[item.MetaDataId || item.FieldKey] || ""
        }));
        return updatedSortColumns;
    };

    const toggleSortOrder = (index: number) => {
        setSortColumns(prev =>
            prev.map((col, i) =>
                i === index ? { ...col, SortOrder: col.SortOrder === 'asc' ? 'desc' : 'asc' } : col
            )
        );
    };

    const handleConfirm = () => {
        SelectMetadataFormData.SortColumnsForOrderBy = sortColumnsForOrderBy.filter(
            column => column.MetaDataId !== -1
        );
        const updatedSortColumns = updateSortColumnsWithFieldNames(selectedColumns, SelectMetadataFormData.SortColumnsForOrderBy)
        SelectMetadataFormData.SortColumnsForOrderBy = updatedSortColumns;
        SelectMetadataFormData.AdditionalButtons = additionalButtons;
        SelectMetadataFormData.drillThruSetColumns = selectedColumns.concat(customcolunms);

        setShowConfirmation(true);
    };

    const handleButtonsJsonChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = event.target.value;
        try {
            //JSON.parse(newValue);
            setAdditionalButtons(newValue);
        } catch (error) {
            //console.error('Invalid JSON format');
        }
    };

    const handleBackToForm = () => setShowConfirmation(false);
    const handleshowform = (index: number) => {
        setShowForm(prevState => {
            const newShowForm = [...prevState];
            newShowForm[index] = !newShowForm[index];
            return newShowForm;
        });
    };
    const handleFormChange = (index: number, updatedColumn: any) => {
        setcustomcol((prevColumns) => {
            const updatedColumns = [...prevColumns];
            updatedColumns[index] = updatedColumn;
            return updatedColumns;
        });
    };
    const handlcustomcolumns = () => {
        var costumcol = initializeColumn();
        setcustomcol((prevColumns) => [...prevColumns, costumcol]);
        //setSelectedColumns((prevColumns) => [...prevColumns, costumcol]);
        setShowForm((prevShowForm) => {
            const updatedShowForm = [...prevShowForm];
            return updatedShowForm;
        });
        setIsCustomColumn(true);
    };

    const handleDeleteColumn = (index: number) => {
        setSelectedColumns((prevColumns) => prevColumns.filter((_, i) => i !== index));
        setShowForm((prevShowForm) => prevShowForm.filter((_, i) => i !== index));
        setCurrentColumnIndex((prevIndex) => {
            return Math.min(prevIndex, sortColumnsForOrderBy.length);
        });
    };
    const handleDeleteCustomColumn = (index: number) => {
        setcustomcol((prevColumns) => prevColumns.filter((_, i) => i !== index));
        setShowForm((prevShowForm) => prevShowForm.filter((_, i) => i !== index));
    };

    return (
        <div>
            {showConfirmation ? (
                <ConfirmationPage
                    CombinedData={SelectMetadataFormData}
                    handleBackToForm={handleBackToForm}
                    isEdit={isEdit}
                />
            ) : (
                <div style={{ padding: '1rem' }}>
                    {/* Back to Admin Tasks Link */}
                    <div className="float-right margin-top-small">
                        <a id="link_backto_admin_tasks" href={`${getBaseUrl()}/ux/index.html#AdminTasks`}>
                            « Back to Admin Tasks
                        </a>
                    </div>

                    {/* Header */}
                    <div className="header" style={{ marginBottom: '1rem' }}>
                        Metadata Drill Thru Configuration
                    </div>

                    {/* Back to Edit Metadata Drill Thru Set Link */}
                    <div className="row d-block" style={{ marginBottom: '1rem' }}>
                        <div className="content">
                            <div className="float-right" style={{ marginRight: '1rem', cursor: 'pointer' }}>
                                <a id="link_backto_admin_tasks" onClick={handleBackForm}>
                                    « Back to Edit Metadata Drill Thru Set
                                </a>
                            </div>
                            <h3 className="fw-normal" style={{ marginLeft: '15px', fontSize: '18px' }}>
                                Configure Metadata Drill Thru Set Columns
                            </h3>
                        </div>
                    </div>

                    {/* Top Button Row */}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '1rem',
                            flexWrap: 'wrap',
                        }}
                    >
                        {/* Left Side: Select MDSC Columns and Add Custom Columns */}
                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                            <label htmlFor="DrillThruSetName" className="input-label" style={{ marginRight: '10px' }}>
                                Select MDSC Columns:
                            </label>
                            <span onClick={openpp} style={{ cursor: 'pointer', flexGrow: 1, minWidth: '200px' }}>
                                <FoundationsInput
                                    type="text"
                                    id="DrillThruSetName"
                                    value={columnNames}
                                    maxLength={100}
                                    inputClasses="hl-ui-editable"
                                    placeHolder=" - not mapped - "
                                    containerClasses="hl-ui-editable-container"
                                    customStyle={{ width: '100%' }}
                                />
                            </span>
                            {/* Add Custom Columns Button */}
                            <FoundationsButton
                                customStyle={{ marginLeft: '1rem', marginTop: '0.5rem' }}
                                id="customcolumns"
                                buttonClasses="ui-button app-button"
                                onClick={handlcustomcolumns}
                            >
                                Add Custom Columns
                            </FoundationsButton>
                        </div>

                        {/* Right Side: Advanced Settings Button */}
                        <div style={{ marginTop: '0.5rem' }}>
                            <FoundationsButton
                                buttonClasses="ui-button app-button"
                                id="btn_advanced_settings"
                                onClick={toggleAdvancedSettings}
                            >
                                {showAdvancedSettings ? 'Hide Advanced Settings' : 'Show Advanced Settings'}
                            </FoundationsButton>
                        </div>
                    </div>

                    {/* Main Content Area: MDSC Forms and Advanced Settings */}
                    <hr />
                    <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
                        {/* Left Column: MDSC Forms */}
                        <div style={{ flex: '1 1 49%', minWidth: '300px' }}>
                            {/* Render Selected Columns */}
                            {selectedColumns?.map((column, index) => (
                                <div key={index} style={{ marginBottom: '1rem' }}>
                                    {/* Buttons Container */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        {/* Toggle Button */}
                                        <span style={{ maxWidth: '15rem', width: '15rem' }}>
                                            <FoundationsButton
                                                buttonClasses="ui-button app-button"
                                                id={`element_button_${index}`}
                                                onClick={() => handleshowform(index)}
                                            >
                                                {`Toggle ${column.FieldName}`}
                                            </FoundationsButton>
                                        </span>

                                        {/* Delete Button */}
                                        <FoundationsButton
                                            buttonClasses="ui-button app-button"
                                            id={`delete_button_${index}`}
                                            onClick={() => handleDeleteColumn(index)}
                                            customStyle={{ marginLeft: '11rem' }}
                                        >
                                            Delete
                                        </FoundationsButton>

                                    </div>

                                    {/* Conditionally Rendered Form */}
                                    {showForm[index] && (
                                        <MDSCForm
                                            index={index}
                                            column={column}
                                            onFormChange={(updatedColumn) => handleFormChange(index, updatedColumn)}
                                            isCustomCol={false}
                                        />
                                    )}
                                    <hr />
                                </div>
                            ))}

                            {/* Render Custom Columns */}
                            {isCustomColumn &&
                                customcolunms.length > 0 &&
                                customcolunms.map((column, index) => (
                                    <div key={selectedColumns.length + index} style={{ marginBottom: '1rem' }}>
                                        {/* Buttons Container */}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                            {/* Toggle Button */}
                                            <span style={{ maxWidth: '15rem', width: '15rem' }}>
                                                <FoundationsButton
                                                    buttonClasses="ui-button app-button"
                                                    id={`element_button_${selectedColumns.length + index}`}
                                                    onClick={() => handleshowform(selectedColumns.length + index)}
                                                >
                                                    {`Toggle ${column.FieldKey ? column.FieldName : 'Custom Column ' + (index + 1)}`}
                                                </FoundationsButton>
                                            </span>

                                            {/* Delete Button */}
                                            <FoundationsButton
                                                buttonClasses="ui-button app-button"
                                                id={`delete_button_${selectedColumns.length + index}`}
                                                onClick={() => handleDeleteCustomColumn(index)}
                                                customStyle={{ marginLeft: '11rem' }}
                                            >
                                                Delete
                                            </FoundationsButton>
                                        </div>

                                        {/* Conditionally Rendered Form */}
                                        {showForm[selectedColumns.length + index] && (
                                            <MDSCForm
                                                index={index}
                                                column={column}
                                                onFormChange={(updatedColumn) => handleFormChange(index, updatedColumn)}
                                                isCustomCol={isCustomColumn}
                                            />
                                        )}
                                        <hr />
                                    </div>
                                ))}
                        </div>


                        {/* Right Column: Advanced Settings (conditionally rendered) */}
                        {showAdvancedSettings && (
                            <div style={{ flex: '1 1 35%', minWidth: '300px' }}>
                                <div style={{ padding: '1rem', borderRadius: '4px' }}>
                                    {/* Sort Columns Section */}
                                    <div>
                                        <label className="input-label">Sort Columns:</label>
                                        <FoundationsButton
                                            buttonClasses="ui-button app-button"
                                            id="btn_add_sort_columns"
                                            onClick={addSortColumn}
                                            customStyle={{ marginLeft: '10px' }}
                                        >
                                            +
                                        </FoundationsButton>

                                        {sortColumnsForOrderBy?.map((col, index) => (
                                            <div
                                                key={col.MetaDataId}
                                                style={{ display: 'flex', alignItems: 'center', marginTop: '10px', flexWrap: 'wrap' }}
                                            >
                                                <FoundationsSelect
                                                    id={`drillthruset_sort_columns_${index}`}
                                                    customStyle={{ width: '100%', maxWidth: '300px', marginBottom: '0.5rem' }}
                                                    onChange={(e: any) => handleSortColumnChange(e.target.value, index)} // Pass the value directly
                                                    value={Number(col.MetaDataId) ?? -1} // Set the current value
                                                >
                                                    <option value="">Select a column</option>
                                                    {selectedColumns?.map((item, idx) => (
                                                        <option selected={col.MetaDataId == item.MetaDataId} key={item.MetaDataId} value={Number(item.MetaDataId)}>
                                                            {item.FieldName}
                                                        </option>
                                                    ))}
                                                </FoundationsSelect>

                                                <FoundationsButton
                                                    buttonClasses="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only mds-button-delete"
                                                    id={`btn_delete_sort_column_${index}`}
                                                    onClick={() => deleteSortColumn(index)}
                                                    customStyle={{ marginLeft: '10px', marginTop: '0.5rem' }}
                                                >
                                                    Delete
                                                </FoundationsButton>

                                                <FoundationsButton
                                                    buttonClasses="ui-button app-button"
                                                    id={`btn_toggle_sort_order_${index}`}
                                                    onClick={() => toggleSortOrder(index)}
                                                    customStyle={{ marginLeft: '10px', marginTop: '0.5rem' }}
                                                >
                                                    Toggle Sort Order ({col.SortOrder || 'asc'})
                                                </FoundationsButton>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Additional Buttons Section */}
                                    <div style={{ marginTop: '20px' }}>
                                        <label htmlFor="additionalButtons">Additional Buttons:</label>
                                        <textarea
                                            id="additionalButtons"
                                            value={additionalButtons}
                                            onChange={handleButtonsJsonChange}
                                            rows={5}
                                            cols={60}
                                            style={{ display: 'block', marginTop: '10px', width: '100%' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Action Buttons */}
                    <div style={{ display: 'flex', marginTop: '1rem', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                        <FoundationsButton
                            buttonClasses="ui-button app-button"
                            customStyle={{ marginRight: '1rem', marginBottom: '0.5rem' }}
                            id="cancel"
                            onClick={handleBackForm}
                        >
                            Cancel
                        </FoundationsButton>
                        <FoundationsButton buttonClasses="ui-button app-button" id="Confirm" onClick={handleConfirm}>
                            Confirm
                        </FoundationsButton>
                    </div>
                </div>
            )
            }
        </div >

    );
};

export default AddMDSC;